// extracted by mini-css-extract-plugin
export var details = "_lm-0";
export var inspectorPopover = "_lm-1";